import { LoadType } from '@tencent/ark-extensions';
import ArkLoader from '@src/js/common/ark-extensions';
import { VipTabType } from '../avatar-nick-nameplate/type';

export const PAY_EXTENSION = {
    name: 'docs-component-pay',
    loadType: LoadType.ON_DEMAND,
};


export type ShowOptions = {
    source?: string;
    onSuccess?: () => void;
    extParam?: {
        state?: number;
        rights_id?: string;
        // 非必填，不传或传0，代表显示打开的支付组件支持SVIP和VIP购买，1 代表只支持SVIP购买，2 代表只支持VIP购买
        vipTabType?: VipTabType;
    }
};


export async function openPay(aid: string, anchor?: string, other?: ShowOptions): Promise<void> {
    const payExtension = await ArkLoader.extensionService.getExtension(PAY_EXTENSION.name);
    let showOption: ShowOptions = { source: aid };
    let extParam;
    if (anchor) {
        extParam = { state: 1, rights_id: anchor };
        showOption = { ...showOption, extParam };
    }
    if (other) {
        showOption = { ...showOption, ...other };
    }
    payExtension.show(showOption);
}
